
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from '@/store';
import { User } from '@/types/app';
import { groupLinkPath } from '@/constants';
import { alphabetize, lowerCaseIncludes, useModalState } from '@/utils';
import { AuthorityLevels } from '@/enums';
import CopyToClipboard from '@/components/CopyToClipboard.vue';
import UserEditFormModal from '@/components/modal/UserEditFormModal.vue';
import UserDeleteFormModal from '@/components/modal/UserDeleteFormModal.vue';
import UsersTable from '@/components/tables/UsersTable.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';

export default defineComponent({
  name: 'UsersManager',
  components: {
    CopyToClipboard,
    UserEditFormModal,
    UserDeleteFormModal,
    UsersTable,
    MaterialIconButton,
    TextInput,
    ButtonInput
  },
  setup() {
    const store = useStore();
    const searchValue = ref('');
    const users = computed(() => store.getters.users.get);
    const filteredUsers = computed(() =>
      users.value.filter(
        user =>
          lowerCaseIncludes(user.name, searchValue.value) ||
          lowerCaseIncludes(user.email, searchValue.value) ||
          lowerCaseIncludes(AuthorityLevels[user.authorityLevel], searchValue.value)
      )
    );

    const sortedUsers = computed(() => alphabetize(filteredUsers.value, 'name'));

    const groupLinkId = computed(() => store.getters.groups.getLinkId);
    onMounted(() => store.dispatch.groups.getLinkId());
    const groupLink = computed(() => `${window.location.origin}/${groupLinkPath}/${groupLinkId.value}`);

    const createNewLink = async () => {
      await store.dispatch.groups.createNewGroupLink();
    };

    const canDeleteUser = (user: User) =>
      store.getters.users.getCurrentUser?.authorityLevel &&
      user.authorityLevel &&
      store.getters.users.getCurrentUser.authorityLevel > user.authorityLevel;

    const [selectedAddEditVendor, isAddEditModalOpen, openAddEditModal] = useModalState<User>();
    const [selectedDeleteVendor, isDeleteModalOpen, openDeleteModal] = useModalState<User>();

    return {
      searchValue,
      groupLink,
      sortedUsers,
      canDeleteUser,
      createNewLink,
      selectedAddEditVendor,
      isAddEditModalOpen,
      openAddEditModal,
      selectedDeleteVendor,
      isDeleteModalOpen,
      openDeleteModal
    };
  }
});
